module.exports = __webpack_public_path__ + "static/media/EFJ.89ad7e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EFJ.jpg
// module id = 1735
// module chunks = 1